import { render } from "./AddMedia.vue?vue&type=template&id=e81e8b16&ts=true"
import script from "./AddMedia.vue?vue&type=script&lang=ts"
export * from "./AddMedia.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__